<template>
  <div class="home">
    <el-container class="out">
      <el-aside width="240px">
        <div class="logo" @click="toMain()">智能配电监控云平台</div>
        <el-menu
          background-color="#111111"
          text-color="#6B7CA7"
          router
          active-text-color="#2A7AFF"
          :default-active="$route.path"
        >
          <el-menu-item index="/super" v-if="resourceIds.indexOf('8') > -1">
            <span slot="title">项目管理</span>
          </el-menu-item>
          <!-- <el-menu-item index="/super/role" v-if="resourceIds.indexOf('10') > -1">
            <span slot="title">角色管理</span>
          </el-menu-item> -->
          <el-menu-item
            index="/super/user"
            v-if="resourceIds.indexOf('11') > -1"
          >
            <span slot="title">账户管理</span>
          </el-menu-item>
          <!-- <el-menu-item index="/super/alarm" v-if="resourceIds.indexOf('9') > -1">
            <span slot="title">告警管理</span>
          </el-menu-item> -->
          <el-menu-item
            index="/super/otherRole"
            v-if="resourceIds.indexOf('99') > -1"
          >
            <span slot="title">角色管理[其他平台]</span>
          </el-menu-item>
          <el-menu-item
            index="/super/otherResource"
            v-if="resourceIds.indexOf('99') > -1"
          >
            <span slot="title">资源管理[其他平台]</span>
          </el-menu-item>
                    <el-menu-item
            index="/super/warnConfig"
            v-if="resourceIds.indexOf('99') > -1"
          >
            <span slot="title">告警配置[其他平台]</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-container class="main">
        <el-header>
          <div class="left" @click="back">
            <i class="iconfont icon-fanhuijiantou"></i>
            <p>返回配电平台</p>
          </div>
          <div class="right">
            <img src="../../assets/images/person.png" />
            <p>欢迎 {{ name }}</p>
            <img src="../../assets/images/icon/logout.png" @click="logout" />
          </div>
        </el-header>
        <el-main>
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: "Home",
  data() {
    return {
      name: "",
      resourceIds: [],

    };
  },
  
  created() {
    this.name = JSON.parse(this.$getCookie("userInfo")).userName;
    setTimeout(() => {
    this.resourceIds = this.$getCookie("resourceIds").split(",");
    }, 1000);
  },
  methods: {
    back() {
      this.$router.push("/project");
    },
        toMain(){
 this.$router.push("/project");
    },
    logout() {
      this.$http.post("/bma-auth-service/sys/signOut").then((res) => {
        window.localStorage.clear();
        this.$clearAllCookie();
        this.$disconnect()
          this.$store.commit("setAlarmStatus", false);
        localStorage.stop = true;
        this.$router.push("/");
      });
    },
  },
};
</script>

<style lang="less" scoped>
.out {
  height: 100%;
  .el-aside {
    background: linear-gradient(180deg, #131c26 0%, #152f57 66%, #0e3c83 100%);
    font-size: 14px;
    position: fixed;
    z-index: 22;
    height: 100%;
    .logo {
      font-size: 16px;
      color: #ffffff;
      height: 78px;
      cursor: pointer;
      line-height: 78px;
      text-align: center;
    }
    li {
      font-size: 14px;
      padding-left: 60px !important;
      width: 240px;
      border-bottom: 1px solid #000000;
    }
  }
}
.main {
  .el-header {
    height: 78px;
    background: #f8f8f9;
    padding: 0 25px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    position: fixed;
    z-index: 10;
    .left {
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-left: 240px;
      i {
        margin-right: 12px;
      }
      p {
        font-size: 18px;
        font-weight: 500;
        color: #161820;
        opacity: 1;
      }
    }
    .right {
      display: flex;
      align-items: center;
      img {
        width: 37px;
        margin-right: 20px;
        cursor: pointer;
        &:not(:first-of-type) {
          width: 30px;
          height: 30px;
        }
      }
      .el-badge {
        margin-right: 20px;
        img {
          width: 30px;
          height: 30px;
          margin: 0;
        }
      }
      p {
        line-height: 27px;
        color: #445a5a;
        margin-right: 20px;
      }
    }
  }
  span {
    font-size: 16px;
    color: #445a5a;
    margin: 0 15px;
  }
  .icon-out {
    width: 30px;
    height: 30px;
    background: #f1f1f1;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .icon-user {
    font-size: 25px;
    color: #445a5a;
  }
  .icon-tuichu {
    font-size: 16px;
    color: #445a5a;
    cursor: pointer;
  }
  .el-main {
    padding: 0;
    margin-top: 60px;
    margin-left: 240px;
    background: #ececec;
  }
}
</style>